export default __webpack_public_path__ + "static/media/temperature.b09ef1e4.svg";